import styled from "styled-components";
import moment from "moment-timezone";
import { RATypography, RAImage, RAMap } from "@/components/customs";
import { Row, Col, Divider, Grid } from "antd";
import { SvgCalendar, SvgCharter, SvgCheck, SvgProfile } from "@/assets/icons";
import { lightTheme } from "@/themes/ThemeConfig";
import { IconSuccess } from "@/assets/images";
import { AirportLegInfo } from "@/components/molecules";
import { RAEmptyLegLabel } from "@/components/atoms";
import { useSelector } from "react-redux";
import { selectFormatDateTimeFull } from "@/stores/slices/authSlice";
import { formatCurrency } from "@/utils";
const { useBreakpoint } = Grid;

export function CardSendInquirySucess({ data = {} }) {
	const {
		label,
		additionalNote = "",
		additionalInfo = {},
		from_airport,
		to_airport,
		aircraft,
		departureDatetime,
		passengers,
		price_inc_tax = 0,
	} = data;
	const formatDTFull = useSelector(selectFormatDateTimeFull);
	const screens = useBreakpoint();

	const getTrips = () => {
		let trips = [];
		trips.push({ from_airport, to_airport });
		return trips;
	};

	const _renderLegByType = () => {
		return (
			<WrapperFlightInfo>
				<WrapperLegInfo className="ra-box-d">
					<AirportLegInfo from_airport={from_airport} to_airport={to_airport} />
					<WrapperLabel>
						<RAEmptyLegLabel label={label} />
					</WrapperLabel>
				</WrapperLegInfo>
				<RAMap trip={getTrips()} />
				<WrapperItem>
					<CardItem
						icon={<SvgCalendar color="#595959" />}
						label="Departure time"
						value={moment(departureDatetime).format(formatDTFull)}
					/>
					<CardItem
						icon={<SvgProfile color="#595959" />}
						label="Passengers"
						value={`${passengers ?? 1} PAX`}
					/>
					<CardItem icon={<SvgCharter color="#595959" />} label="Aircraft" value={aircraft?.name ?? "_"} />
				</WrapperItem>
			</WrapperFlightInfo>
		);
	};

	const _renderAdditionalInfo = () => {
		return (
			<WrapperAdditionalRequest>
				<RATypography variant="sub-heading4" color="#121216">
					Additional Requests
				</RATypography>
				{!!additionalNote && (
					<RATypography variant="body3" color="#65686F">
						{additionalNote}
					</RATypography>
				)}
				<WrapperRequestServices>
					{Object.keys(additionalInfo).map((v) => {
						if (!!additionalInfo[v]) {
							const title =
								v === "is_bring_pet"
									? "I’m bringing a pet"
									: v === "is_bring_oversize_luggage"
										? "I’m bringing oversized luggage"
										: "";
							return (
								<Row gutter={[12, 12]} key={`additiona-reqeust-${v}`}>
									<Col>
										<SvgCheck color={lightTheme.color_status_success_500} />
									</Col>
									<Col>
										<RATypography variant="sub-heading4" color="#222222">
											{title}
										</RATypography>
									</Col>
								</Row>
							);
						}
					})}
				</WrapperRequestServices>
			</WrapperAdditionalRequest>
		);
	};

	const _renderPrice = () => {
		return (
			<Row gutter={[20, 12]} justify="start" align="middle">
				<Col>
					<RATypography variant="label3" color="#A8A8A8">
						PRICE
					</RATypography>
				</Col>
				<Col>
					<RATypography variant="label1" color="#222222">
						{!price_inc_tax ? "REQUEST PRICING" : formatCurrency(price_inc_tax, "USD", 0)}
					</RATypography>
				</Col>
			</Row>
		);
	};

	return (
		<ContainerRequestFlight data-testid="sendInquiryModal_content">
			<RAImage url={IconSuccess} width="50px" height="50px" />
			<div>
				<RATypography variant="h4" align="center">
					Inquiry Sent Successfully!
				</RATypography>
				<RATypography variant="body3" color="#595959" align="center" top="8px">
					Thank you for your empty leg inquiry! Our team will get back to you shortly.
				</RATypography>
			</div>
			<WrapperEmptyLegInfo>
				{_renderLegByType()}
				<Divider />
				{_renderAdditionalInfo()}
				<Divider />
				{_renderPrice()}
			</WrapperEmptyLegInfo>
		</ContainerRequestFlight>
	);
}

const CardItem = ({ icon, label = "", value = "" }) => (
	<Row align="top">
		<Col xl={8} lg={12} md={12} xs={24}>
			<Row gutter={8}>
				<Col>{icon}</Col>
				<Col>
					<RATypography variant="body3" color="#595959">
						{label}
					</RATypography>
				</Col>
			</Row>
		</Col>
		<Col xl={16} lg={12} md={12} xs={24}>
			<RATypography variant="sub-heading4" color="#222222">
				{value}
			</RATypography>
		</Col>
	</Row>
);

const ContainerRequestFlight = styled.div`
	width: "100%";
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
`;
const WrapperEmptyLegInfo = styled.div`
	padding: 20px;
	width: 100%;
	min-height: 100px;
	background: #fafafa;
	border-radius: 12px;
`;
const WrapperFlightInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	@media (max-width: 576px) {
		margin-top: 0px;
	}
`;
const WrapperItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 20px;
`;
const WrapperLegInfo = styled.div`
	width: 100%;
	padding: 24px clamp(4px, 2vw, 20px);
	gap: 16px;
	min-height: 72px;
	border: 1px dashed #e9e8e8;
	border-radius: 10px;
	position: relative;
`;
const WrapperAdditionalRequest = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const WrapperRequestServices = styled.div`
	margin-top: 12px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
const WrapperLabel = styled.div`
	position: absolute;
	top: 0px;
	left: 0px;
`;
